module.exports = __webpack_public_path__ + "media/table_3f18b9.png";